import { detect as webcastle } from '@/service/api/webcastle'
import ruleI18n from '../rule.i18n'

import codes from '@/codes';

const temp_i18n = {
  'Country detected of user policy' : '사용자 정책의 국가 IP 기반 탐지',
  'IPAddress detected of user policy' : '사용자 정책의 IP 주소 탐지',
  'Host detected of user policy' : '호스트가 사용자 정책 탐지',
  'Path detected of user policy' : '사용자 정책의 경로 탐지',
  'Parameter detected of user policy' : '사용자 정책의 매개 변수 탐지',
}

export default {
  data : () => {
    return {
      model : { message : { messages : [], unique_id : "", time_stamp : "" } },
      is_error : false,
      codes,
      ruleI18n,
      error_check : false,
      temp_i18n
    }
  },
  methods: {
    list() { this.$router.push({ name: 'webcastle_log'}); },
    async get({ id } = this.$route.params) {
      console.log('detect.detail.vue', 'load item', id);
      try {
        let rs = await webcastle.detailDetect({ id : id })
        if(rs.error) { return this.$toastr.e("load", "failed"); }
        this.model = Object.assign({}, this.model, rs.body);

        if(this.model.message.length){
          this.model.message = JSON.parse(this.model.message);
        }else{
          return
        }
        if(!this.model.message.unique_id) { this.is_error = true }
      } catch(e) {this.error_check = true, this.$toastr.e(e ? e.data ? e.data : e : e.statusText)}
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('detect.detail.vue', 'created'); },
  destroyed() { console.log('detect.detail.vue', 'destroyed'); },
  mounted() {
    console.log('detect.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}